// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__XSoan","loadingShrink":"PageLoading_loadingShrink__2zoQR"};